<template>
    <div class="detail-wrapper">
        <div style="height: 100%">

            <div style="height: 100%" class="flex-style-column">
                <div class="top-wrapper flex-style-row with-full-size">
                    <div class="checkbox-wrapper">
                        <p class="checkbox-label">노출 여부</p>
                        <input v-model="innerManual.showYn" class="checked" type="checkbox"/>
                    </div>
                    <input v-model="innerManual.title" type="text" class="with-full-size border-style-radius manual-title-input-style"
                           placeholder="제목을 입력하세요"
                    />
                </div>
                <div class="with-full-size manual-title-content-style">
                    <!--vue quill 라는 라이브러리에서 사용하는 컴포넌트-->
                    <quill-editor
                        ref="editor"
                        :options="options"
                        v-model="innerManual.content"
                        style="width: 100%; height: calc(100% - 50px); background-color: #ffffff; padding: 0px;"
                    />
                </div>
                <div class="sub-content-block">
                    <p class="sub-content-label">부가 내용</p>
                    <textarea
                        v-model="innerManual.subContent"
                        class="sub-content-textarea"
                        rows="8"
                        placeholder="부가 내용을 입력하세요"
                    />
                </div>
                <div class="detail-button-wrapper">
                    <button v-if="clickMenuDepth ===2" @click="completeButton" class="button-complete-style">작성완료</button>
                    <button v-if="clickMenuDepth ===3" @click="updateButton('N')" class="button-update-style">
                        수정완료
                    </button>
                    <button v-if="clickMenuDepth ===3" @click="updateButton('Y')" class="button-delete-style">
                        삭제
                    </button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
/**
 * 메뉴얼에서 상세부분 컨포넌트 입니다.
 * 제목과 내용 노출여부 데이터를 컨트롤 하며 작성하기 수정하기 삭제하기 동작을 수행합니다
 *
 */

export default {
    name: "NewManualDetail",
    props: {
        manual:{
            type: Object,
            default: ()=>{}
        },
        manualWriteData:{
            type: Object,
            default: ()=>{}
        },
        clickMenuDepth:{
            type:Number,
            default: undefined
        }

    },
    data() {
        return {
            /**
             * 메뉴얼을 작성 데이터
             */
            innerManual:{
                title: undefined,
                content: undefined, //편집 부분까지 있기때문에 태그가 String 되서 저장됨
                subContent: undefined,
                showYn:false,
                parentId:undefined
            },
            /**
             * 내용부분에 글자 굵기 폰트 이미지 첨부등 할 수 있게 옵션을 세팅한다.
             */
            options: {
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            [{ 'script': 'sub'}, { 'script': 'super' }],
                            [{ 'indent': '-1'}, { 'indent': '+1' }],
                            [{ 'direction': 'rtl' }],
                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'font': [] }],
                            [{ 'align': [] }],
                            ['clean'],
                            ['image'],
                        ],
                    },
                    imageDrop: true,
                    imageResize: {
                        modules: [ 'Resize', 'DisplaySize' ]
                    },
                }
            },
        }
    },
    methods: {
        /**
         * 작성완료버튼 누를때 동작합니다.
         */
        completeButton() {
            if(!this.innerManual.title){
                this.$alert("제목을 입력해주세요")
                return
            }
            this.$confirm("저장하시겠습니까?")
                .then(()=>this.$emit("insert-data-rq"))
        },
        /**
         * 수정완료버튼 누를때 동작합니다.
         */
        updateButton(deleteYn){
            this.$confirm(`${deleteYn==='Y'?'삭제':'수정'}하시겠습니까?`)
                .then(()=>this.$emit("update-data-rq",deleteYn))
        }
    },
    watch:{
        innerManual :{
            deep:true,
            immediate:true,
            handler(newValue){
                this.$emit("change-write-data",newValue)
            }
        },
        manualWriteData: {
            deep:true,
            immediate:true,
            handler(newValue){
                this.innerManual=newValue
            }
        },
    },


}
</script>

<style scoped>
/*공통으로 사용하는 Css 부분입니다*/
.border-style-radius{
    border:1px solid #cccccc;
    border-radius: 5px;/*스타일 부분으로 내용작 성시 제외*/
}
.with-full-size{
    width: 100%;
}
.flex-style-column{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.flex-style-row{
    display: flex;

}
/*상세부분 전체 wrapper입니다.*/
.detail-wrapper{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}
/*노출여부 checkbox*/
.checkbox-wrapper{
    align-items: center;
    padding: 0px;
    width: 12%;
    display: flex;
    align-items: center;
}
.checkbox-label{
    margin-bottom: 0px;
    margin-right: 5px;
}

input[type=checkbox] {
    cursor: pointer;
    border: 2px solid #555555;
    border-radius: 3px;
    background-color: white;
    border: 2px solid #0C98FE;
    width: 20px;
    height: 20px;
}
/*노출여부랑 제목에 관한 wrapper 입니다*/
.top-wrapper{
    margin-bottom: 20px;

}

/*작성하는 input textarea 부분입니다.*/
.manual-title-input-style{
    height: 50px;
    width: 100%;
    padding-left: 12px;
}
.manual-title-content-style{
    height: 100%;
    width: 100%;
    overflow: auto;
    white-space: nowrap;
    resize: none;
}
.sub-content-block {
    width: 100%;
    margin-top: 16px;
    flex-shrink: 0;
}
.sub-content-label {
    margin: 0 0 8px 0;
    font-weight: 600;
    font-size: 14px;
}
.sub-content-textarea {
    width: 100%;
    box-sizing: border-box;
    padding: 10px 12px;
    border: 1px solid #cccccc;
    border-radius: 5px;
    font-size: 14px;
    resize: vertical;
    min-height: 120px;
}
/*버튼 그룹입니다.*/
.detail-button-wrapper{
    display: flex;
    width: 100%;
}

/*작성하기 버튼 부분입니다.*/
.button-complete-style{
    background-color: #42b983 !important;
    border-color: #42b983 !important;
    padding: 6px 0;
    border-radius: 5px;
    width: 100%;
    color: #eeeeee;
    margin-top: 10px;
    margin-right: 20px;
}
/*수정하기 버튼 부분입니다.*/
.button-update-style{
    background-color: #1976d2 !important;
    border-color: #1976d2 !important;
    padding: 6px 0;
    border-radius: 5px;
    width: 100%;
    color: #eeeeee;
    margin-top: 10px;
    margin-right: 20px;
}

/*삭제하기 버튼 부분입니다.*/
.button-delete-style{
    background-color: red !important;
    border-color: red !important;
    padding: 6px 0;
    width: 100%;
    border-radius: 5px;
    color: #eeeeee;
    margin-top: 10px;
    margin-left: 20px;
}

>>> .ql-editor{
    overflow: auto;
    white-space: nowrap;
}

</style>